import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/builder')({
	component: BuilderLayout,
})

function BuilderLayout() {
	return (
		<div className="flex h-full flex-col overflow-hidden">
			<Outlet />
		</div>
	)
}
